import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { createFrameMemo } from "../../rail/FrameMemo/memo";
import { allLocationRuns } from "../LocationRun/catalog";
import { layoutLocationBoxes } from "./layout";
import type { LocationBoxPlacement } from "./types";

/** Further from the playhead than this, a box is off screen at any automatic zoom. */
const NEAR_PLAYHEAD_MS = 90_000;

const memo = createFrameMemo<BookTimelineLayout, LocationBoxPlacement[]>();

/**
 * Placements for the boxes around the playhead. A whole book has thousands of boxes,
 * and laying them all out every frame costs more than everything else put together.
 */
export function nearLocationPlacements(
  layout: BookTimelineLayout,
  playheadMs: number,
  viewportWidth: number,
): LocationBoxPlacement[] {
  return memo(layout, playheadMs, String(viewportWidth), () => layoutLocationBoxes(
    layout.beats,
    playheadMs,
    viewportWidth,
    layout.totalDurationMs,
    undefined,
    allLocationRuns(layout).filter((run) => (
      run.startMs - playheadMs < NEAR_PLAYHEAD_MS
      && playheadMs - run.endMs < NEAR_PLAYHEAD_MS
    )),
    layout.rail,
  ));
}
